export function formatToman(value){

return `${Number(
value||0
).toLocaleString("fa-IR")} تومان`;

}

export function calculateWithdrawalProgress(
available,
minimum
){

if(!minimum) return 0;

return Math.min(
100,
Math.round(
(available/minimum)*100
)
);

}


export function getRemainingWithdrawalText(
available,
minimum
){

const remain=
Math.max(
0,
minimum-available
);

if(remain<=0)
return "امکان برداشت فعال شد";

return `برداشت از ${formatToman(remain)} دیگر فعال می‌شود`;
}


export function buildReferralMessage(
code,
link
){

return `من با موجیم برنامه تمرین و تغذیه هوشمند گرفتم 💪

تو هم با کد ${code}
تخفیف بگیر:

${link}`;
}


export function buildReferralLink(
code
){

return `${window.location.origin}/?ref=${code}`;

}


export function validateSheba(
sheba
){

if(!sheba)
return false;

return /^IR[0-9]{24}$/i.test(
sheba.replace(/\s/g,'')
);

}